import { AxiosResponse } from 'axios';

export enum Type {
    Boolean = 'BOOLEAN',
    Date = 'DATE',
    Float = 'FLOAT',
    Int = 'INT',
    Reference = 'REFERENCE',
    String = 'STRING',
    Text = 'TEXT',
}

export interface Model {
    id: number;
    type: Type;
    name: string;
    reference_type: number | null;
    reference_type_name: null | string;
    is_label: boolean;
    is_array: boolean;
    is_required: boolean;
    is_sequence: boolean;
    reference_model?: { [key: string]: Model };
}

export class Response<T> {
    item!: T;
    items!: T[];
    folder!: T;
    result!: string;
    message!: string;
    success!: boolean;
    keys!: string[];
    model!: Model[];
    row_count!: number;
    total_pages!: number;
    fetched_results!: Record<string, Record<string, any>>;

    constructor(response: AxiosResponse) {
        this.success = !!response.data.success;
        if (response.data.url){
            this.item = response.data as T
        }
        if (response.data.items) this.items = response.data.items as T[];
        if (response.data.contents) this.items = response.data.contents as T[];
        if (response.data.folder) this.folder = response.data.folder as T;
        if (response.data.item) this.item = response.data.item as T;
        if (response.data.message) this.message = response.data.message;
        if (response.data.keys) this.keys = response.data.keys;
        if (response.data.model) this.model = response.data.model;
        if (response.data.row_count) this.row_count = response.data.row_count;
        if (response.data.total_pages) this.total_pages = response.data.total_pages;
        if (response.data.results) this.items = response.data.results as T[];
        if (response.data.result) this.result = response.data.result;
        if (response.data.fetched_results) this.fetched_results = response.data.fetched_results;
    }
}

